import { QueueModel } from '@/types';

export interface RealtimeReportFilter {
    queues: QueueModel[];
}

export interface RealtimeReportState {
    filter: RealtimeReportFilter;
}
